/* eslint-disable */
import React from 'react';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';
import CheckoutWithApplePayUI from './CheckoutWithApplePayUI';

const CheckoutWithApplePayWrapper = props => {
  const postHogFlag = usePostHogFeatureFlag('applePayInCart');

  if (postHogFlag === 'test') {
    return <CheckoutWithApplePayUI {...props} />;
  }

  return null;
};

// CheckoutWithApplePay.propTypes = {};

export default CheckoutWithApplePayWrapper;
